import { useQuery } from '@tanstack/react-query';
import { Action, Subject } from '@erp/authz';
import { OPEN_TASK_STATUSES, SystemEntity } from '@erp/shared-types';
import { orpc } from '@/api/rpc/client';
import { useCan } from '@/hooks/useCan';

/**
 * Whether this invoice has open tasks anchored to it. Used to offer closing
 * those tasks when the invoice is ignored. Callers who cannot read tasks get
 * a false result; ignore still closes the tasks unless they opt out.
 */
export function useOpenInvoiceTasks(invoiceId: string) {
  const [canReadTasks] = useCan(Action.Read, Subject.Task);
  const query = useQuery({
    ...orpc.tasks.list.queryOptions({
      input: {
        anchorEntityType: SystemEntity.AP_INVOICE,
        anchorEntityId: invoiceId,
        statuses: [...OPEN_TASK_STATUSES],
        limit: 1,
        offset: 0,
      },
    }),
    enabled: canReadTasks,
  });

  return {
    hasOpenTasks: (query.data?.pagination.total ?? 0) > 0,
    isLoading: canReadTasks && query.isLoading,
  };
}
